import { useState } from 'react';
import PropTypes from 'prop-types';
import { PlainButton } from '../ButtonsV2';
import FilterModal from './FilterModal';
import FilterIcon from '../Icons/FilterIconV2';

/**
 * FilterComponent
 * This component renders a button that opens a filter modal when clicked.
 * It manages the state of whether the modal is open and passes necessary props
 * to the FilterModal for handling the filter values and actions.
 * When filters are applied those values are passed to its parent component
 *
 * @param {function} onApplyFilter - A function that will be called when the "Apply" button is clicked, passing the current filter values.
 * @param {function} onClearFilter - A function that will be called when the "Clear" button is clicked, to reset the filters.
 * @param {object} initialFilterValues - An object containing the initial values for the filters.
 * @param {boolean} isFilterLoading - A boolean indicating whether the filter is currently loading (used to disable the "Apply" button).
 */
const FilterComponent = ({
  onApplyFilter,
  onClearFilter,
  initialFilterValues,
  isFilterLoading = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const onClickFilterButton = () => {
    setIsOpen(true);
  };

  const onCloseFilterModal = () => {
    setIsOpen(false);
  };

  const onClickClear = () => {
    setIsOpen(false);
    onClearFilter();
  };

  return (
    <div className="relative">
      <PlainButton onClick={onClickFilterButton} customClass="flex items-center">
        <span className="mr-4">
          <FilterIcon />
        </span>
        Filters
      </PlainButton>
      {isOpen && (
        <FilterModal
          initialFilterValues={initialFilterValues}
          onClear={onClickClear}
          onApply={onApplyFilter}
          isFilterLoading={isFilterLoading}
          onClose={onCloseFilterModal}
        />
      )}
    </div>
  );
};

FilterComponent.propTypes = {
  onApplyFilter: PropTypes.func.isRequired,
  onClearFilter: PropTypes.func.isRequired,
  initialFilterValues: PropTypes.object.isRequired,
  isFilterLoading: PropTypes.bool,
};

export default FilterComponent;
